import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { MatRadioModule } from '@angular/material/radio';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { CommonModule } from '@angular/common';
import { TaskEditTaskAssigneeComponent } from './task-edit-task-assignee.component';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SelectSearchModule,
        MatRadioModule,
        FiProfileIconModule,
        FiAppTextSharedModule,
        MatIconModule,
    ],
    declarations: [TaskEditTaskAssigneeComponent],
    exports: [TaskEditTaskAssigneeComponent],
})
export class TaskEditTaskAssigneeModule {}
